import React from "react";
import Reveal from "@/components/site/Reveal";
import Spark from "@/components/brand/Spark";

/**
 * EditorialBreak — full-bleed editorial image strip with overlaid label.
 * Used to give the eye a break between content-dense sections.
 */
export const EditorialBreak = ({
  image,
  eyebrow,
  headline,
  subline,
  testid,
}) => (
  <section
    className="relative h-[44vh] md:h-[52vh] min-h-[360px] overflow-hidden"
    data-testid={testid}
  >
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${image})` }}
    />
    <div className="absolute inset-0 bg-gradient-to-r from-[#2A2422]/85 via-[#2A2422]/55 to-[#2A2422]/20" />
    <div className="relative h-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col justify-center">
      <Reveal>
        <div className="flex items-center gap-3 text-[#B58B42]">
          <Spark size={14} />
          <p className="eyebrow text-[#B58B42]">{eyebrow}</p>
        </div>
      </Reveal>
      <Reveal delay={120}>
        <h3 className="mt-5 font-display text-3xl md:text-5xl text-[#F3EFE7] max-w-2xl leading-tight">
          {headline}
        </h3>
      </Reveal>
      {subline && (
        <Reveal delay={240}>
          <p className="mt-4 font-body text-[#F3EFE7]/80 max-w-xl leading-relaxed">
            {subline}
          </p>
        </Reveal>
      )}
    </div>
  </section>
);

export default EditorialBreak;
